export default __webpack_public_path__ + "static/media/wiz2.48958982.png";